
import { Button } from "@/components/ui/button";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { MessageList } from "@/components/messages/MessageList";
import { ArrowLeft } from "lucide-react";
import type { Database } from "@/integrations/supabase/types";

type Client = Database["public"]["Tables"]["clients"]["Row"];

interface MessageHistoryProps {
  client: Client;
  onBack: () => void;
}

export function MessageHistory({ client, onBack }: MessageHistoryProps) {
  const { data: messages } = useQuery({
    queryKey: ["messages", client.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("generated_messages")
        .select(`
          *,
          clients (
            client_name
          )
        `)
        .eq("client_id", client.id)
        .order("created_at", { ascending: false });

      if (error) throw error;
      return data;
    },
  });

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" onClick={onBack} className="gap-2">
          <ArrowLeft className="h-4 w-4" />
          Back to Profile
        </Button>
      </div>

      <MessageList
        messages={messages || []}
        messageType="email"
        description={`Message history for ${client.client_name}`}
      />
    </div>
  );
}
